export const GET_GOOGLE_FB_Ad = "GET_GOOGLE_FB_Ad";

export const EDIT_GOOGLE_FB_AD = "EDIT_GOOGLE_FB_AD";

export const SHOW_TOGGLE = "SHOW_TOGGLE";

export const SET_UPDATE_GOOGLE_FB_AD_DONE = "SET_UPDATE_GOOGLE_FB_AD_DONE";
export const UNSET_UPDATE_GOOGLE_FB_AD_DONE = "UNSET_UPDATE_GOOGLE_FB_AD_DONE";
